<template>
  <v-content>
    <Navbar
      class="py-0"
      @drawerCtrl="drawerCtrl"
    />
    <Sidebar
      :drawer.sync="drawer"
    />
    <slot />
  </v-content>
</template>

<script>
import Navbar from '@/module/layouts/Navbar'
import Sidebar from '@/module/layouts/Sidebar'
export default {
  components: {
    Navbar,
    Sidebar
  },
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    drawerCtrl () {
      this.drawer = !this.drawer
    }
  }
}
</script>

<style>

</style>
